/******************************************************************************\
 * :$
 *
 * Copyright(c) 2022 SAS Institute Inc., Cary, NC, USA. All Rights Reserved.
 *
 * Name: GSEditor
 *
 * Purpose:
 *
 * Author: craig (Craig.Simpson@sas.com)
 *
 * Support: SAS(r) Solutions OnDemand
 *
 * Input:
 *
 * Output:
 *
 * Parameters: (if applicable)
 *
 * Dependencies/Assumptions:
 *
 * Usage:
 *
 * History:
 * ddmmmyyyy userid description (Change Code)
 * 15Sep2022 craig File created.
 \******************************************************************************/
import React from "react";
import {CKEditor} from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
//import WordCount from '@ckeditor/ckeditor5-word-count/src/wordcount';

interface GSEditorProps {
    onChange: any,
    editorLoaded: boolean,
    disabled:boolean,
    name: string,
    value: string
}

/*
const editorConfig = {
    plugins: [WordCount]
}
*/

function makeid() {
    const len = 5;
    let result = '';
    const characters:string = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength:number = characters.length;
    for ( var i = 0; i < len; i++ ) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
}
export const GSEditor: React.FC<GSEditorProps> = ({onChange, editorLoaded, disabled, name, value}: GSEditorProps) => {
    return (
        <div>
            {editorLoaded ? (<CKEditor
                onReady={(editor:any) => {
                    editor.editing.view.change((writer) => {
                        writer.setStyle(
                            "height",
                            "250px",
                            editor.editing.view.document.getRoot()
                        );
                    })
                }}
                //config={editorConfig}
                type={""}
                name={name + "-" + makeid()}
                disabled={disabled}
                editor={ClassicEditor}
                data={value}
                onChange={(event: any, editor: any) => {
                    onChange(editor.getData())
                }}
                onInit={() => {console.log('here')}}
            />) : (
                <div>Editor loading</div>
            )}
        </div>
    )
}
/*
export const GSEditor = React.forwardRef((props: any, ref:any) => {
    console.log(props.values);
        return (
            <CKEditor editor={ClassicEditor}
                      onReady={(editor:any) => {
                          editor.editing.view.change((writer) => {
                              writer.setStyle(
                                  "height",
                                  "250px",
                                  editor.editing.view.document.getRoot()
                              );
                          })
                      }}
                      disabled={props.disabled}
                      data={props.values}
                      onChange={(evt, editor) => {
                          props.onChange(evt.editor.getData())
                      }}
                      onDistroy={console.log('here destroy')}
            />
        )
    });*/
